import * as S from './styles'

export default function Error({ children }: { children: any | null }) {
    let message = children
    if (children.message) {
        message = children.message
    }
    try {
        let json = JSON.parse(message)
        if (json.detail) {
            message = json.detail
        }
    } catch {
    }
    return <S.Container><h1>{message}</h1></S.Container>
}